import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

import "core-js/modules/es6.array.sort.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.regexp.constructor.js";
import "core-js/modules/es6.array.map.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import classnames from 'classnames';
import FormControl from '../../wui-input/src';
import PropTypes from 'prop-types';
import { WebUI, prefix } from "../../wui-core/src/index.js";
var propTypes = {
  value: PropTypes.any,
  show: PropTypes.bool,
  disabled: PropTypes.bool,
  options: PropTypes.array,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  onSelectOption: PropTypes.func,
  onValueChang: PropTypes.func,
  placeholder: PropTypes.string
};
var defaultProps = {
  value: "",
  show: false,
  disabled: false,
  options: [],
  onBlur: function onBlur() {},
  onKeyDown: function onKeyDown() {},
  onValueChange: function onValueChange() {},
  onChange: function onChange() {},
  onSelectOption: function onSelectOption() {},
  placeholder: ''
};
var AutoComplete = (_dec = WebUI({
  name: "autocomplete",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(AutoComplete, _React$Component);

  var _super = _createSuper(AutoComplete);

  function AutoComplete(props) {
    var _this;

    _classCallCheck(this, AutoComplete);

    _this = _super.call(this, props);
    _this.state = {
      show: props.show,
      //控制自动匹配列表的显示与隐藏
      displayValue: '',
      activeItemIndex: -1,
      options: props.options,
      value: props.value,
      placeholder: props.placeholder
    };
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    _this.handleLeave = _this.handleLeave.bind(_assertThisInitialized(_this));
    _this.handleEnter = _this.handleEnter.bind(_assertThisInitialized(_this));
    _this.handleChangeList = _this.handleChangeList.bind(_assertThisInitialized(_this));
    _this.moveItem = _this.moveItem.bind(_assertThisInitialized(_this));
    _this.handLeBlur = _this.handLeBlur.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AutoComplete, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ('value' in nextProps && nextProps.value !== this.props.value) {
        var value = nextProps.value;
        this.setState({
          value: value
        });
      }

      if ('options' in nextProps && nextProps.options !== this.props.options) {
        var options = nextProps.options;
        this.setState({
          options: options
        });
      }

      if ('show' in nextProps && nextProps.show !== this.props.show) {
        var show = nextProps.show;
        this.setState({
          show: show
        });
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(value) {
      var arr = [];
      var valueArr = this.props.options;
      valueArr.sort();

      if (value.replace(/(^\s*)|(\s*$)/g, '') == "") {
        this.setState({
          value: "",
          activeItemIndex: -1,
          show: false
        });
        this.props.onValueChange(value);
        this.props.onChange(value);
        return;
      }

      for (var i = 0; i < valueArr.length; i++) {
        if (valueArr[i].indexOf(value) != -1) {
          arr.push(valueArr[i]);
        }
      }

      this.setState({
        options: arr,
        show: true,
        activeItemIndex: -1,
        displayValue: '',
        value: value
      });
      this.props.onValueChange(value);
      this.props.onChange(value);
    }
    /**
     * 自动匹配的列表被选中其中某一个
     * @param {*} value
     */

  }, {
    key: "handleChangeList",
    value: function handleChangeList(value) {
      this.setState({
        show: false,
        displayValue: ''
      });
      this.props.onValueChange(value);
      this.props.onChange(value);
      this.props.onSelectOption(value);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var _this$state = this.state,
          displayValue = _this$state.displayValue,
          activeItemIndex = _this$state.activeItemIndex;
      var _this$props = this.props,
          onValueChange = _this$props.onValueChange,
          onKeyDown = _this$props.onKeyDown,
          onChange = _this$props.onChange;
      onKeyDown(e);

      switch (e.keyCode) {
        // 13为回车键的键码（keyCode）
        case 13:
          {
            this.setState({
              show: false
            });
            onValueChange(displayValue, activeItemIndex);
            onChange(displayValue, activeItemIndex);
            break;
          }
        // 38为上方向键，40为下方向键

        case 38:
        case 40:
          {
            e.preventDefault(); // 使用moveItem方法对更新或取消选中项

            this.moveItem(e.keyCode === 38 ? 'up' : 'down');
            break;
          }
      }
    }
  }, {
    key: "moveItem",
    value: function moveItem(direction) {
      var _this$state2 = this.state,
          activeItemIndex = _this$state2.activeItemIndex,
          options = _this$state2.options;
      var lastIndex = options.length - 1;
      var newIndex = -1; // 计算新的activeItemIndex

      if (direction === 'up') {
        if (activeItemIndex === -1) {
          // 如果没有选中项则选择最后一项
          newIndex = lastIndex;
        } else {
          newIndex = activeItemIndex - 1;
        }
      } else {
        if (activeItemIndex < lastIndex) {
          newIndex = activeItemIndex + 1;
        }
      } // 获取新的displayValue


      var newDisplayValue = '';

      if (newIndex >= 0) {
        newDisplayValue = options[newIndex];
      } // 更新状态


      this.setState({
        displayValue: newDisplayValue,
        activeItemIndex: newIndex
      });
    }
  }, {
    key: "handleEnter",
    value: function handleEnter(index) {
      var currentItem = this.props.options[index];
      this.setState({
        activeItemIndex: index,
        displayValue: currentItem
      });
    }
  }, {
    key: "handleLeave",
    value: function handleLeave() {
      this.setState({
        activeItemIndex: -1,
        displayValue: ''
      });
    }
  }, {
    key: "handLeBlur",
    value: function handLeBlur() {
      var _this2 = this;

      this.props.onBlur(this.state.value);
      setTimeout(function () {
        _this2.setState({
          show: false
        });
      }, 300);
    }
  }, {
    key: "replaceCurrentMatchWord",
    value: function replaceCurrentMatchWord(str) {
      var displayName = this.state.displayValue || this.state.value;
      if (!displayName) return str;
      var regexp = new RegExp(displayName, 'g');
      str = str.replace(regexp, function (match) {
        if (match) {
          return "<span class=\"".concat(prefix, "-autocomplete-match-words\">").concat(match, "</span>");
        } else {
          return "";
        }
      });
      return str;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state3 = this.state,
          show = _this$state3.show,
          displayValue = _this$state3.displayValue,
          activeItemIndex = _this$state3.activeItemIndex,
          options = _this$state3.options;
      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          clsPrefix = _this$props2.clsPrefix;
      var optionList = options.map(function (item, index) {
        var currentData = item.text || item;
        currentData = _this3.replaceCurrentMatchWord(currentData);
        return /*#__PURE__*/React.createElement("li", {
          key: index,
          className: index === activeItemIndex ? "active" : '',
          onMouseEnter: function onMouseEnter() {
            return _this3.handleEnter(index);
          },
          onClick: function onClick() {
            return _this3.handleChangeList(item);
          }
        }, /*#__PURE__*/React.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: currentData
          }
        }));
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classnames(clsPrefix, this.props.className)
      }, /*#__PURE__*/React.createElement(FormControl, {
        value: displayValue || this.state.value,
        disabled: disabled,
        onChange: function onChange(value) {
          _this3.handleChange(value);
        },
        onKeyDown: this.handleKeyDown,
        placeholder: this.state.placeholder,
        onBlur: this.handLeBlur
      }), show && /*#__PURE__*/React.createElement("ul", {
        className: "".concat(clsPrefix, "-options"),
        onMouseLeave: this.handleLeave
      }, options.length ? optionList : /*#__PURE__*/React.createElement("li", {
        className: "not-found",
        style: {
          color: "#999"
        }
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: "暂无相关数据"
        }
      }))));
    }
  }]);

  return AutoComplete;
}(React.Component)) || _class);
AutoComplete.propTypes = propTypes;
export default AutoComplete;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-autocomplete/src/AutoComplete.js